var render, staticRenderFns
import script from "./indexBannerDetail.vue?vue&type=script&lang=js"
export * from "./indexBannerDetail.vue?vue&type=script&lang=js"
import style0 from "./indexBannerDetail.vue?vue&type=style&index=0&id=2b424b51&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b424b51",
  null
  
)

export default component.exports